(function (h) {
    if (h.__locPatch) return;
    const P = h.pushState,
        R = h.replaceState,
        fire = () => window.dispatchEvent(new Event("locationchange"));
    h.pushState = function () {
        const r = P.apply(this, arguments);
        fire();
        return r;
    };
    h.replaceState = function () {
        const r = R.apply(this, arguments);
        fire();
        return r;
    };
    window.addEventListener("popstate", fire);
    h.__locPatch = true;
})(window.history);

function Comp7() {
    $(document)
        .off("click.comp7")
        .on(
            "click.comp7",
            ".comp-7.compCollapse .compCollapse-toggle .btn, .comp-7-footer .btn",
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).closest(".comp-7.compCollapse").toggleClass("show");
            }
        );

    const closeAll = () => $(".comp-7.compCollapse").removeClass("show");

    $(window)
        .off(".comp7")
        .on("hashchange.comp7 locationchange.comp7", closeAll);
}
Comp7();
